import { Injectable } from '@angular/core';

declare var Multipayment: any;

@Injectable({ providedIn: 'root' })
export class GmoService {
  getToken(shopId: string, cc: { name?: string; number?: string; expire_year?: string; expire_month?: string; security?: string }): Promise<string> {
    return new Promise((resolve) => {
      let settled = false;
      const finish = (value: string) => {
        if (settled) return;
        settled = true; clearTimeout(timer); resolve(value);
      };
      const timer = setTimeout(() => finish('error'), 30000);
      const expire = String(cc.expire_year) + ('0' + String(cc.expire_month)).slice(-2);
      try {
        Multipayment.init(shopId);
        Multipayment.getToken(
        {
          holdername: String(cc.name),
          cardno: String(cc.number),
          expire,
          securitycode: String(cc.security),
        },
        (res: any) => {
          if (res?.resultCode === '000' && typeof res.tokenObject?.token === 'string' && res.tokenObject.token) {
            finish(res.tokenObject.token);
          } else {
            finish('error');
          }
        }
        );
      } catch { finish('error'); }
    });
  }
}
